import { Component, OnInit } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ColumnScrollService } from '../../column-scroll.service';

import { ControlColumnSelectionModel } from 'src/app/shared/import/control-column-selection-model';
import { ImportStep } from '../../import-step';

@Component({
    selector: 'control-column-selection',
    templateUrl: './control-column-selection.component.html',
    styleUrls: ['../../general.scss', '../column-selection.scss', './control-column-selection.component.scss']
})
export class ControlColumnSelectComponent extends BaseColumnSelectComponent {
    readonly step = ImportStep.ControlColumn;
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;
    selectedOldControlValue: string;
    selectedNewControlValue: string;
    namedRangesFoundInFile: string[] = [];
    
    loading = true;
    dataLoaded = false;
    showHint = true;

    constructor(private dataService: DataService, private importProgressService: ImportProgressService, projectService: ProjectService, columnScrollService: ColumnScrollService) {
        super(projectService, columnScrollService);
    }

    public async loadDataInternal() {
        let resp = await this.dataService.get<ControlColumnSelectionModel>('columnSelection/control/' + this.projectId);
        this.columns = resp.columns;
        this.stepState = resp.stepState;
        this.namedRangesFoundInFile = resp.namedRangesFoundInFile.map(x => '"' + x + '"');
        let selectedColumn = this.columns.filter(c => c.isSelected)[0];
        this.selectColumn(selectedColumn);
        if (resp.selectedOldControlValue && resp.selectedNewControlValue 
                && selectedColumn.usefulVals.indexOf(resp.selectedOldControlValue) >= 0
                && selectedColumn.usefulVals.indexOf(resp.selectedNewControlValue) >= 0) {
            this.selectedOldControlValue = resp.selectedOldControlValue;
            this.selectedNewControlValue = resp.selectedNewControlValue;
        }
        this.loading = false;
        this.dataLoaded = true;
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    selectColumn(column: ColumnForSelection): void {
        super.selectColumn(column);
        this.selectedOldControlValue = column.usefulVals[0];
        this.selectedNewControlValue = column.usefulVals[1];
    }

    oldControlValChanged($event: MatOptionSelectionChange) {
        let newVal = $event.source.value;
        if ($event.isUserInput && this.selectedNewControlValue == newVal) {
            this.selectedNewControlValue = this.selectedOldControlValue;
        }
    }

    newControlValChanged($event: MatOptionSelectionChange) {
        let newVal = $event.source.value;
        if ($event.isUserInput && this.selectedOldControlValue == newVal) {
            this.selectedOldControlValue = this.selectedNewControlValue;
        }
    }

    selectOldControlValue(val: string) {
        let prevVal = this.selectedOldControlValue;
        this.selectedOldControlValue = val;
        if (this.selectedNewControlValue == val) {
            this.selectedNewControlValue = prevVal;
        }
    }

    selectNewControlValue(val: string) {
        let prevVal = this.selectedNewControlValue;
        this.selectedNewControlValue = val;
        if (this.selectedOldControlValue == val) {
            this.selectedOldControlValue = prevVal;
        }
    }

    async save() {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            const changesApplied = await this.dataService.post<boolean>('columnSelection/control', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
                oldControlVal: this.selectedOldControlValue,
                newControlVal: this.selectedNewControlValue,
            });
            this.finishStepSuccessfully(changesApplied);
        } finally {
            this.loading = false;
        }
    }
}
